import { useTranslation } from "react-i18next";
import AuthPageShell from "../components/AuthPageShell";
import SignupForm from "../components/SignupForm";

const SignupPage = () => {
  const { t } = useTranslation("auth");

  return (
    <AuthPageShell
      title={t("signup.title")}
      subtitle={t("signup.subtitle")}
      maxWidth="lg"
      headerClassName="py-5"
      contentClassName="flex flex-col overflow-hidden px-4 pb-5 pt-5 sm:px-8"
    >
      <SignupForm />
    </AuthPageShell>
  );
};

export default SignupPage;
